import { 
  RecaptchaVerifier,
  signInWithPhoneNumber
} from 'firebase/auth';
import { auth } from './firebaseConfig';

class TwoFactorAuth {
  constructor() {
    this.verifier = null;
    this.confirmationResult = null;
  }

  // Initialize ReCaptcha verifier
  initRecaptcha(buttonId) {
    if (!this.verifier) {
      this.verifier = new RecaptchaVerifier(auth, buttonId, {
        size: 'invisible',
        callback: () => {},
        'expired-callback': () => {}
      });
    }
    return this.verifier;
  }

  // Send verification code
  async sendVerificationCode(phoneNumber, buttonId) {
    try {
      const verifier = this.initRecaptcha(buttonId);
      this.confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, verifier);
      return true;
    } catch (error) {
      console.error('Error sending verification code:', error);
      throw error;
    }
  }

  // Verify code entered by user
  async verifyCode(code) {
    if (!this.confirmationResult) {
      throw new Error('No verification code was sent');
    }
    try {
      const result = await this.confirmationResult.confirm(code);
      return result;
    } catch (error) {
      console.error('Error verifying code:', error);
      throw error;
    }
  }

  // Clear recaptcha
  clearRecaptcha() {
    if (this.verifier) {
      this.verifier.clear();
      this.verifier = null;
    }
  }
}

export const twoFactorAuth = new TwoFactorAuth(); 